import React from 'react'
import { Dialog } from 'evergreen-ui'
import Map from '../../Components/Map'
import * as moment from 'moment';

const ActivityDetail = ({
  detailedItem = null,  visible, close = () => {}
}) => {
  let { createdAt,terminatedAt } = detailedItem
  if (createdAt) {
    createdAt = moment(createdAt).add(-3, 'h').format('DD-MM-YYYYY HH:mm:ss')
  }
  if (terminatedAt) {
    terminatedAt = moment(terminatedAt).add(-3, 'h').format('DD-MM-YYYYY HH:mm:ss')
  }
  return (
    <Dialog
      isShown={visible}
      title="Detalhe das atividades"
      intent="danger"
      onCloseComplete={() => close()}
      hasFooter={false}
      width={750}
    >
      {detailedItem && visible && (
        <Map
          createdAt={createdAt}
          terminatedAt={terminatedAt}
          initialLocation={{ latitude: detailedItem.initialLatitude, longitude: detailedItem.initialLongitude }}
          finalLocation={ (detailedItem.finalLatitude && { latitude: detailedItem.finalLatitude, longitude: detailedItem.finalLongitude }) || null}
        />
      )}
    </Dialog>
  )
}

export default ActivityDetail
